<script>
  export let checked;
  export let label;
  export let disabled = false;
</script>

<label class:disabled
  >{label}
  <input type="checkbox" id="warp-count" bind:checked {disabled} />
</label>

<style>
  label {
    margin-top: 4px;
    margin-bottom: 4px;
  }
  label:not(:first-child) {
    margin-bottom: 4px;
  }
  label:not(:last-child) {
    margin-top: 4px;
  }

  label {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    align-items: center;
  }

  input {
    margin-right: 8px;
    -webkit-appearance: none;
    appearance: none;
    background-color: white;
  }

  input[type='checkbox'] {
    width: 1.2em;
    height: 1.2em;
    border: 1px solid gray;
    vertical-align: -2px;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  input[type='checkbox']::before {
    transition: opacity 100ms;
    content: '✔';
    position: absolute;
    font-size: 1.5em;
    opacity: 0;
  }

  input[type='checkbox']:checked::before {
    opacity: 1;
  }

  input[type='checkbox']:disabled {
    border-color: black;
    background: #ddd;
    color: gray;
  }
</style>
